import { render, staticRenderFns } from "./RotationImage.vue?vue&type=template&id=5c36e47a&scoped=true&"
import script from "./RotationImage.vue?vue&type=script&lang=js&"
export * from "./RotationImage.vue?vue&type=script&lang=js&"
import style0 from "./RotationImage.vue?vue&type=style&index=0&id=5c36e47a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c36e47a",
  null
  
)

export default component.exports